import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  LiveFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const ManageRates = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalcount, setTotalcount] = useState(10);
  const [masters, setMasters] = useState({});

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  async function fetchbrokerprices(searchtext)
  {
    let bodycontent = {
      searchtext,
      offset,
      limit
    }
    let adminusers = await sendNetworkRequest('/admin/getstoreprices', {}, bodycontent,false)
    setTotalcount(adminusers.module.count)
    setOrders(adminusers.module)
  }
  function searchbroker(key,searchtext)
  { 
    
    fetchbrokerprices(searchtext)
  }
  async function fetchmasters() {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {}, true)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {}, true)
    setMasters({
      ...masters,
      languages: languages.module,
      commodity: commodities.module

    })
  }
 async function deletelatestprice(broker_id)
  { 
    let bodycontent = {
      broker_id
    }
    let adminusers = await sendNetworkRequest('/admin/deletestorepricehistory', {}, bodycontent,false)
    alert(adminusers.message)
    fetchbrokerprices()
  }
  function onPageoffset(page)
  {
    setOffset(page)
  }
  function onPagelimit(limit)
  {
    setLimit(limit)
  }
  useEffect(() => {
    fetchbrokerprices()
    fetchmasters()
  }, [offset,limit])
  
  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
       <LiveFilter masters = {masters} hintname="Search by Broker name" onSearch={searchbroker}/> 
      <Results
        className={classes.results}
        orders={orders} 
        onDelete={deletelatestprice}
        
        // totalcount={orders.length}
        // onPageoffset={onPageoffset}
        // onPagelimit={onPagelimit}
      />
     
    </Page>
  );
});

export default ManageRates;
